'use client';

import dynamic from 'next/dynamic';

export const NextImage = dynamic(() => import('next/image'), {
  ssr: false,
});
